export var ChatContents;
(function (ChatContents) {
    /**
     * Media type specification. When not provided:
     * - For type "text": defaults to "text/plain"
     * - For other types: specific MIME type should be provided
     *
     */
    let mediaType;
    (function (mediaType) {
        mediaType["IMAGE_JPG"] = "image/jpg";
        mediaType["IMAGE_PNG"] = "image/png";
        mediaType["IMAGE_GIF"] = "image/gif";
        mediaType["IMAGE_WEBP"] = "image/webp";
        mediaType["AUDIO_WEBM"] = "audio/webm";
        mediaType["AUDIO_MPEG"] = "audio/mpeg";
        mediaType["AUDIO_WAV"] = "audio/wav";
        mediaType["AUDIO_OGG"] = "audio/ogg";
        mediaType["AUDIO_MP4"] = "audio/mp4";
        mediaType["AUDIO_FLAC"] = "audio/flac";
        mediaType["APPLICATION_PDF"] = "application/pdf";
        mediaType["TEXT_CSV"] = "text/csv";
        mediaType["TEXT_PLAIN"] = "text/plain";
        mediaType["APPLICATION_JSON"] = "application/json";
        mediaType["APPLICATION_XML"] = "application/xml";
    })(mediaType = ChatContents.mediaType || (ChatContents.mediaType = {}));
})(ChatContents || (ChatContents = {}));
